
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
export const sanitize = function (obj) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Manager';
  const children = Array.isArray(obj.children) ? obj.children.filter(child => child) : [obj.children].filter(child => child);
  const ret = {};
  ret.type = type;
  ret.name = obj.name || (obj.props || {}).name || `Anonymous ${type}`;
  if (ret.name === 'Anonymous Group') return null;
  ret.props = _objectSpread({}, obj.props);
  Object.keys(ret.props).forEach(propName => {
    if (typeof ret.props[propName] === 'function') {
      ret.props[propName] = null;
    }
  });
  if (type === 'Manager') {
    ret.input = obj.input;
  }
  delete ret.props.children;
  if (type === 'Manager') {
    ret.groups = (children || []).map(child => sanitize(child, 'Group')).filter(val => val);
  }
  return ret;
};
export const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    //eslint-disable-line
    let r = Math.random() * 16 | 0;
    let v = c == 'x' ? r : r & 0x3 | 0x8; //eslint-disable-line
    return v.toString(16);
  });
};
export const fsToRules = expConfig => {
  if (!expConfig) return [];
  const fields = Object.keys(expConfig).filter(key => /^fs-/.test(key)).map(key => {
    let val = expConfig[key];
    if (val === 'true') val = true;
    if (val === 'false') val = false;
    if (/^\d+$/.test(val)) val = parseInt(val, 10);
    if (/^\d+\.\d+$/.test(val)) val = parseFloat(val);
    if (/^fs-disable/.test(key)) {
      const parts = /^fs-disable:([\w-]+)__([\w-]+)/.exec(key);
      if (parts && parts.length === 3) {
        const [, managerName, groupName] = parts;
        return {
          type: 'disable',
          key,
          value: val,
          managerName,
          groupName
        };
      }
    }
    if (/^fs-prop/.test(key)) {
      const parts = /^fs-prop:([\w-]+)__([\w-]+)--(\w+)/.exec(key);
      if (parts && parts.length === 4) {
        const [, managerName, groupName, propName] = parts;
        return {
          type: 'prop',
          key,
          value: val,
          managerName,
          groupName,
          propName
        };
      }
    }
    return null;
  }).filter(val => val);
  return fields;
};
//# sourceMappingURL=util.js.map